import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "mx-1",
  textContent: '/'
}
const _hoisted_4 = {
  key: 1,
  textContent: 'N/A'
}
const _hoisted_5 = ["textContent"]

import { onMounted } from 'vue';
import { PERMISSIONS } from '@/enum';
import { can, useDateTime } from '@/composables';
import { useArchiveStore } from '@/store';

interface Menu {
  label: string;
  icon: {
    name: string;
    styles: string;
  };
  styles: string;
  command: () => void;
  visible: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersToBeArchived',
  setup(__props) {

const archiveStore = useArchiveStore();

const createMenuModel = (item: Menu) => {
  return [
    {
      label: 'Archive',
      icon: {
        name: 'vpn_key',
        styles: 'inline-block text-lg',
      },
      styles: '',
      command: () => onArchive(item.person_id, item.person_name, item.archive_reason_id),
      visible: can([PERMISSIONS.PEOPLE_ARCHIVE]),
    },
    {
      label: 'Keep',
      icon: {
        name: 'cancel',
        styles: 'inline-block text-lg',
      },
      styles: '',
      command: () => onKeep(item.person_id),
      visible: can([PERMISSIONS.PEOPLE_ARCHIVE_KEEP]),
    },
  ];
};

onMounted(async () => init());

const init = async () => await archiveStore.toBeArchived();

const onArchive = async (personId: number, person_name: string, archiveReasonId: number) => {
  await archiveStore.archive(personId, archiveReasonId ? { archived_reason_id: archiveReasonId } : {});
  await archiveStore.toBeArchived();
  archiveStore.doToast(`${person_name} has been archived`, 'Archived');
};

const onKeep = async (personId: number) => await archiveStore.archiveKeep(personId);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _unref(archiveStore).peopleToBeArchived,
          loading: _unref(archiveStore).peopleToBeArchivedLoading,
          "data-key": "student_id",
          paginator: "",
          rows: _unref(archiveStore).peopleToBeArchivedTotal,
          "rows-per-page-options": [15, 25, 30],
          "paginator-template": "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
          "responsive-layout": "scroll"
        }, {
          empty: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("No users to be archived found", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "name",
              header: "Name"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_RouterLink, {
                    to: `/user/${data.person_id}`,
                    target: "_blank",
                    class: "font-semibold",
                    textContent: _toDisplayString(data.person_name)
                  }, null, 8, ["to", "textContent"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "organization",
              header: "Organization"
            }, {
              body: _withCtx(({ data }) => [
                (data.organizations.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.organizations, (organization, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        _createVNode(_component_RouterLink, {
                          to: `/organizations/${organization.organization_id}`,
                          target: "_blank",
                          class: "font-semibold",
                          textContent: _toDisplayString(organization.organization_name)
                        }, null, 8, ["to", "textContent"]),
                        (data.organizations.length > 0 && key !== data.organizations.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "person_type_title",
              header: "Type"
            }),
            _createVNode(_component_Column, {
              field: "archive_at",
              header: "To Be Archived"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.archive_at))
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "actions",
              header: "Actions",
              "header-style": "max-width: 50px;",
              "body-style": "max-width: 50px;"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_ActionMenu, {
                  class: "ml-3",
                  "menu-items": createMenuModel(data),
                  icon: "more_horiz"
                }, null, 8, ["menu-items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading", "rows"])
      ]),
      _: 1
    })
  ]))
}
}

})